import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/Dialog';
import { ClientForm } from './ClientForm';
import type { Client } from '../../../core/models/Client';

interface ClientEditDialogProps {
  open: boolean;
  onClose: () => void;
  client: Client;
  onSubmit: (data: any) => Promise<void>;
}

export const ClientEditDialog: React.FC<ClientEditDialogProps> = ({
  open,
  onClose,
  client,
  onSubmit,
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Edit Project</DialogTitle>
        </DialogHeader>
        <ClientForm
          initialData={client}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
